export enum LocationType {
  POI = 'POI',
  Geography = 'Geography',
  Street = 'Street',
  PointAddress = 'Point Address',
  AddressRange = 'Address Range',
  CrossStreet = 'Cross Street'
}
